import React, { useEffect } from "react";
import { X } from "lucide-react";

const Modal = ({ title, isOpen, onClose, children }) => {
  // Melhoria de UX: Fechar ao pressionar ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    // Overlay com Blur e Fundo Escuro
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4 transition-opacity duration-300"
      onClick={onClose}
    >
      {/* Container do Modal 
          - RESTAURADO: dark:bg-dark-card (Para garantir a cor correta do seu tema)
          - MANTIDO: border-transparent/white-5 (Para o visual Clean sem bordas duras)
      */}
      <div
        className="relative w-full max-w-2xl bg-light-card dark:bg-dark-card border border-transparent dark:border-white/5 rounded-xl shadow-2xl flex flex-col max-h-[90vh] animate-fade-in-up"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Cabeçalho do Modal */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-light-border dark:border-transparent shrink-0">
          {/* RESTAURADO: Cores de texto do tema para garantir contraste */}
          <h2 className="text-xl font-bold tracking-tight text-light-text-primary dark:text-dark-text-primary">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg text-light-text-secondary dark:text-dark-text-secondary hover:bg-light-hover hover:text-light-text-primary dark:hover:bg-white/5 dark:hover:text-dark-text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-brand-blue"
            aria-label="Fechar modal"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Conteúdo do Modal */}
        <div className="p-6 pt-2 overflow-y-auto custom-scrollbar text-light-text-secondary dark:text-dark-text-secondary">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
